import React, { useEffect, useState } from 'react'

export default function ToolSpecs({initialSpecs= [],setAttributes}) {
  let initialSpecs1 = [
    {
      "name": "overall length",
      "label": "L1",
      "value": 10,
      "unit": "mm",
      "x": 10,
      "y": 27
    },
    {
      "name": "head angle",
      "label": "A",
      "value": 5,
      "unit": "deg",
      "x": 100,
      "y": 48
    },
    {
      "name": "tip diameter",
      "label": "D1",
      "value": 8,
      "unit": "mm",
      "x": 65,
      "y": 65
    },
    {
      "name": "overall diameter",
      "label": "D2",
      "value": 22,
      "unit": "mm",
      "x": 10,
      "y": 65
    }
  ]; 
  const [scale, setScale] = useState(1);
  //const specs = getSpecsFromLocalStorage();
  const defaultContainerWidth = 800;

  useEffect(() => {
    function handleScaling() {
      const container = document.querySelector('.tool-container1');
      if (container) {
        container.style.width = `${defaultContainerWidth}px`;

        const currentContainerWidth = container.getBoundingClientRect().width;
        const newScale = currentContainerWidth / defaultContainerWidth;
        setScale(newScale);
      }
    }

    window.addEventListener('resize', handleScaling);
    handleScaling();

    return () => window.removeEventListener('resize', handleScaling);
  }, []);

  // console.log("initialSpecs", initialSpecs)
  const extractValue = (str) => {
    const match = str.match(/\(([^)]+)\)/);
    return match ? match[1] : null;
  };

  const handleSpecInput=(attribute_uuid, value)=>{
    // console.log("attribute_uuid", attribute_uuid , "---", value); 
    
 let arr=  initialSpecs.map(item => {
      if (item.uuid === attribute_uuid) {
        return { ...item, ["attribute_value"]: value }; 
      }
      return item; 
    });

    // console.log("arr----",arr)

   setAttributes(arr)

  }

  return Object.values(initialSpecs).map((spec) => {
    if(spec.x_position == "" || spec.y_position == ""){
      return null;
    }
    // console.log("scale", scale
    // console.log("spec", spec)
    const style = {
      left: `${spec.x_position}%`,
      top: `${spec.y_position}%`,
      transform: `zoom(${scale})`,
      transformOrigin: 'top left',
    };

    

    return (
      <div key={spec.label} className="spec align-item-center" style={style}>
        <label htmlFor={spec.label} className="unit">
          <input
             className='productInbox text-center'
            placeholder={extractValue(spec.toolparameter?.parameters_code)}
            name={spec.label}
            defaultValue={spec.value ?? ''}
            type="number"
            onChange={(e)=>{
              console.log("specs",spec)
              handleSpecInput(spec.uuid,e.target.value)
            }}
            form="tool-form"
          />
          {extractValue(spec.uom_value)}
        </label>
      </div>
    );
  });
}